// @flow

import * as React from 'react';

import Toolbar from './Components/Toolbar';
import Table from './Components/Table'


type Props = {
  searchTerm: string,
  project: {},
  fetching: Boolean,
  selectedOrderIds: [],

  componentWillMount: Function,
  onClickNewOrder: Function,
  onChangeSearch: Function,
  onChangeSelectedRows: Function,
}

export default class extends React.PureComponent<Props> {

  componentWillMount = () => this.props.componentWillMount()

  render(){
    const {
      searchTerm,
      project,
      fetching,
      selectedOrderIds,
      onClickNewOrder,
      onChangeSearch,
      onChangeSelectedRows,
    } = this.props;


    return(
      <React.Fragment>

        <Toolbar
          searchTerm={searchTerm}
          onClickNewOrder={onClickNewOrder}
          onChangeSearch={onChangeSearch}
        />

        <Table 
          project={project} 
          fetching={fetching} 
          selectedOrderIds={selectedOrderIds}
          onChangeSelectedRows={onChangeSelectedRows} 
        />

      </React.Fragment>
    )
  }
}
